import React, { useState } from "react";
import API_URL from "../config";

const Connectemp = () => {
  const [phone, setPhone] = useState("");
  const [resultat, setResultat] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [client, setClient] = useState(null);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" ou "error"
  const [showModal, setShowModal] = useState(false); // 🔹 affiche ou cache la modal
  const [fadeOut, setFadeOut] = useState(false); // ✅ pour l’animation de disparition
  const onPhoneChange = (e) => {
    setPhone(e.target.value);
  };
  //tresseuse_exist    tresseuse
  const handleconnect = async (e) => {
    const lphone = client.codetres;

    setResultat(null);

    try {
      const res = await fetch(`${API_URL}/tresseuse/${phone}/`);
      const data = await res.json();
      setResultat(data);
      if (data.existe === true) {
        setMessage("...Ckeck in succesfuly...");
        setMessageType("success");
        setShowModal(true);
        setFadeOut(false);
        setTimeout(() => setFadeOut(true), 3000);
        setTimeout(() => setShowModal(false), 4000);
      } else {
        setMessage(
          "...Please " +
            client.nomtres +
            " ack Administrator Check you out first..",
        );
        setMessageType("error");
        setShowModal(true);
        setFadeOut(false);
        setTimeout(() => setFadeOut(true), 8000);
        setTimeout(() => setShowModal(false), 9000);
      }
    } catch (err) {
      //  setErreur("Erreur de connexion au serveur.");
    }
    setSubmitted(false);
    setPhone("");
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setClient(null);
    setResultat(null);

    try {
      const res = await fetch(`${API_URL}/tresseuse_exist/${phone}/`);
      const data = await res.json();
      setResultat(data);
      if (data.existe === true) {
        setClient(data);
        setSubmitted(true);
      } else {
        setClient(null);
        setMessage("...Your are not yet register contact administrator..");
        setMessageType("error");
        setShowModal(true);
        setFadeOut(false);
        setTimeout(() => setFadeOut(true), 8000);
        setTimeout(() => setShowModal(false), 9000);
        setSubmitted(false);
        setPhone("");
      }
    } catch (err) {
      //  setErreur("Erreur de connexion au serveur.");
    }
  };
  const handleReset = () => {
    setSubmitted(false);
    setClient(null);
    setPhone("");
  };
  return (
    <div className="container-fluid" style={styles.pageBackground}>
      {/* Bandeau avec effet défilant */}
      <div style={styles.marqueeContainer}>
        <marquee behavior="scroll" direction="left" scrollamount="6">
          <span style={styles.marqueeText}>
            WELCOME TO NADINE'S HAIR BRAIDING &nbsp; | &nbsp; Tel: (202)
            706-2506 &nbsp; | &nbsp; Address: 4501 Mitchellville Road, Bowie, MD
            20716
          </span>
        </marquee>
      </div>

      <div id="corps" className="text-center mt-5">
        {/* 🔹 Fenêtre modale avec animation */}
        {showModal && (
          <div
            style={{
              ...styles.modalOverlayFull,
              opacity: fadeOut ? 0 : 1,
              transition: "opacity 0.8s ease",
            }}
          >
            <div
              style={{
                ...styles.modalCentered,
                border:
                  messageType === "success"
                    ? "2px solid #c3e6cb"
                    : "2px solid #f5c6cb",
                backgroundColor:
                  messageType === "success" ? "#d4edda" : "#f8d7da",
                color: messageType === "success" ? "#155724" : "#721c24",
                boxShadow: "0 6px 20px rgba(0, 0, 0, 0.25)",
              }}
            >
              <h3 style={{ fontWeight: "bold", margin: 0 }}>{message}</h3>
            </div>
          </div>
        )}
        {!submitted ? (
          <>
            {/* Formulaire principal */}
            <div className="row justify-content-center mt-1">
              <div className="col-md-4 col-lg-4">
                <div className="p-4 p-md-5" style={styles.loginWrap}>
                  <div
                    className="d-flex align-items-center justify-content-center mb-3"
                    style={styles.icon}
                  >
                    <img
                      src={require("../../assets/images/logo_fenasu.png")}
                      alt="logo"
                      style={{ width: "200px" }}
                    />
                  </div>

                  <form onSubmit={handleSubmit} id="lg-form" name="fnewathlete">
                    <div className="form-group mb-3">
                      <input
                        type="text"
                        name="ltelephone"
                        id="ltelephone"
                        className="form-control form-control-lg rounded"
                        placeholder="Enter your employee code"
                        required
                        value={phone}
                        onChange={onPhoneChange}
                        autoFocus
                      />
                    </div>

                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg w-100 fw-bold"
                      >
                        <h5>.....Search your information.....</h5>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {client ? (
              <div
                className="col-md-5 mx-auto my-5 p-5 shadow-lg rounded-5 bg-light text-dark"
                style={{
                  borderTop: "6px solid #0d6efd",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 20px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 5px 15px rgba(0,0,0,0.1)";
                }}
              >
                <h2
                  className="text-center text-primary fw-bold mb-5"
                  style={{ fontSize: "2rem" }}
                >
                  ✅ BRAIDER INFORMATION FOUND ✅
                </h2>

                <div className="mb-5">
                  <p
                    className="mb-3"
                    style={{ fontSize: "2.1rem", textAlign: "left" }}
                  >
                    <strong className="text-secondary">👤 Names:</strong>{" "}
                    <span className="fw-semibold text-dark">
                      {client.nomtres}
                    </span>
                  </p>
                  <p
                    className="mb-3"
                    style={{ fontSize: "2.1rem", textAlign: "left" }}
                  >
                    <strong className="text-secondary">📞 Phone:</strong>{" "}
                    <span className="fw-semibold text-dark">
                      {client.tletres}
                    </span>
                  </p>
                </div>

                <div
                  className="d-flex justify-content-center align-items-center gap-5 mt-5"
                  style={{ flexWrap: "wrap" }}
                >
                  <button
                    className="btn"
                    style={{
                      fontSize: "1.4rem",
                      minWidth: "200px",
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, #0d6efd, #0954c6)",
                      color: "white",
                      border: "none",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                      transition: "all 0.25s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.07)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(0, 0, 0, 0.35)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #d1e495ff, #adf775ff)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0, 0, 0, 0.3)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #0d6efd, #0954c6)";
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.transform = "scale(0.96)";
                    }}
                    onMouseUp={(e) => {
                      e.currentTarget.style.transform = "scale(1.07)";
                    }}
                    onClick={() => handleconnect()}
                  >
                    🔁 Check In
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button
                    className="btn"
                    style={{
                      fontSize: "1.4rem",
                      minWidth: "200px",
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, #dc3545, #b02a37)",
                      color: "white",
                      border: "none",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                      transition: "all 0.25s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.07)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(0, 0, 0, 0.35)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #e35d6a, #d63342)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0, 0, 0, 0.25)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #dc3545, #b02a37)";
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.transform = "scale(0.96)";
                    }}
                    onMouseUp={(e) => {
                      e.currentTarget.style.transform = "scale(1.07)";
                    }}
                    onClick={() => handleReset()}
                  >
                    ❌ Cancel
                  </button>
                </div>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

// 🎨 Styles
const styles = {
  pageBackground: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f9f9f9 0%, #e6ecff 100%)",
    paddingBottom: "40px",
  },
  marqueeContainer: {
    background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
    padding: "10px 0",
    borderBottom: "4px solid #fff",
    borderTop: "4px solid #fff",
  },
  marqueeText: {
    color: "white",
    fontWeight: "bold",
    fontSize: "1.3rem",
    letterSpacing: "1px",
  },
  loginWrap: {
    background: "#fff",
    borderRadius: 11,
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
  },
  icon: {
    marginBottom: 10,
  },
  warningText: {
    color: "#d9534f",
    fontWeight: "bold",
    backgroundColor: "#fff5f5",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #f5c6cb",
  },
  resultBox: {
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },
  // Dans ton objet styles
  modalOverlayFull: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 3000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(3px)",
    transition: "opacity 0.8s ease",
  },

  modalCentered: {
    padding: "30px 60px",
    borderRadius: "14px",
    textAlign: "center",
    fontSize: "1.5rem",
    background: "#fff",
    maxWidth: "500px",
    width: "80%",
    animation: "scaleUp 0.5s ease forwards", // ✅ animation ajoutée
  },
};

export default Connectemp;
